import { render } from "./StatusTag.vue?vue&type=template&id=1ec907d8&scoped=true"
import script from "./StatusTag.vue?vue&type=script&lang=js"
export * from "./StatusTag.vue?vue&type=script&lang=js"

import "./StatusTag.vue?vue&type=style&index=0&id=1ec907d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec907d8"]])

export default __exports__